import {
  IconButton,
  Stack,
  Dialog,
  DialogType,
  DialogFooter,
  PrimaryButton,
  DefaultButton,
} from '@fluentui/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalValues } from '../../../types';
import { setNodeScrollState } from '../../Conditions';
import { cutToast } from 'utility/toast';

export const DeleteCondition: React.FC<{ data: any }> = ({ data }) => {
  const [showDialog, setShowDialog] = useState(false);
  const { getValues, setValue } = useFormContext<ApprovalValues>();
  const onDelete = () => {
    const conditions = getValues('approvalSelectionConditions') || [];
    const updatedConditions = conditions.filter(
      (item) => item.importanceLevel !== data.importanceLevel
    );

    setValue('approvalSelectionConditions', updatedConditions, {
      shouldDirty: true,
    });

    cutToast.info('Condition removed');
    setNodeScrollState(true);
    setShowDialog(false);
  };

  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Delete' }}
        title="Delete Condition"
        ariaLabel="Delete Condition"
        onClick={() => {
          setNodeScrollState(false);
          setShowDialog(true);
        }}
        disabled={!!data?.disabled}
      />

      {showDialog && (
        <Dialog
          hidden={false}
          onDismiss={() => {
            setNodeScrollState(true);
            setShowDialog(false);
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'Delete Condition',
            subText: 'Are you sure you want to delete this condition?',
          }}
        >
          <DialogFooter>
            <PrimaryButton onClick={onDelete} text="Delete" />
            <DefaultButton
              onClick={() => {
                setNodeScrollState(true);
                setShowDialog(false);
              }}
              text="Cancel"
            />
          </DialogFooter>
        </Dialog>
      )}
    </Stack>
  );
};
